import React from 'react';
import PropTypes from 'prop-types';

export default function Users(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 1153 807" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M173.657 345.6C237.197 345.6 288.857 293.94 288.857 230.4C288.857 166.86 237.197 115.2 173.657 115.2C110.117 115.2 58.4572 166.86 58.4572 230.4C58.4572 293.94 110.117 345.6 173.657 345.6ZM980.057 345.6C1043.6 345.6 1095.26 293.94 1095.26 230.4C1095.26 166.86 1043.6 115.2 980.057 115.2C916.517 115.2 864.857 166.86 864.857 230.4C864.857 293.94 916.517 345.6 980.057 345.6ZM1037.66 403.2H922.457C890.777 403.2 862.157 415.98 841.277 436.68C913.817 476.46 965.297 548.28 976.457 633.6H1095.26C1127.12 633.6 1152.86 607.86 1152.86 576V518.4C1152.86 454.86 1101.2 403.2 1037.66 403.2ZM576.857 403.2C688.277 403.2 778.457 313.02 778.457 201.6C778.457 90.18 688.277 0 576.857 0C465.437 0 375.257 90.18 375.257 201.6C375.257 313.02 465.437 403.2 576.857 403.2ZM715.097 460.8H700.157C662.717 478.8 621.137 489.6 576.857 489.6C532.577 489.6 491.177 478.8 453.557 460.8H438.617C324.137 460.8 231.257 553.68 231.257 668.16V720C231.257 767.7 269.957 806.4 317.657 806.4H836.057C883.757 806.4 922.457 767.7 922.457 720V668.16C922.457 553.68 829.577 460.8 715.097 460.8ZM312.437 436.68C291.557 415.98 262.937 403.2 231.257 403.2H116.057C52.5172 403.2 0.857178 454.86 0.857178 518.4V576C0.857178 607.86 26.5972 633.6 58.4572 633.6H177.077C188.417 548.28 239.897 476.46 312.437 436.68Z"
        fill={iconColor}
      />
    </svg>
  );
}

Users.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Users.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: '#000'
};
